import Role from './Role'

export default class User {
  id?: number
  name?: string
  loginName?: string
  roles: Array<Role> = []
  roleIds: Array<string> = []
}